var _path, _circle, _path2, _path3, _path4, _path5, _path6, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _ellipse, _circle12, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationAmpersand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 600,
    viewBox: "0 0 900 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h900v600H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 440.554,
    cy: 307.567,
    r: 265.881,
    stroke: "url(#a)",
    strokeWidth: 2.797
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.078 307.567c0-81.363 65.958-147.321 147.321-147.321 81.364 0 147.322 65.958 147.322 147.321 0 4.5-.081 20.273-4.81 34.46-2.333 7-5.382 12.292-8.92 15.672-3.099 2.962-7.194 5.114-13.893 5.114-7.436 0-11.013-2.04-13.452-4.534-3.064-3.131-6.339-9.11-8.874-20.265-5.183-22.804-5.297-57.092-5.297-104.107 0-10.171-8.245-18.416-18.415-18.416-10.168 0-18.412 8.242-18.415 18.409-15.389-11.559-34.518-18.409-55.246-18.409-50.852 0-92.076 41.224-92.076 92.076s41.224 92.076 92.076 92.076c27.506 0 52.195-12.061 69.067-31.183 2.839 5.725 6.383 11.006 10.852 15.575 10.509 10.742 24.196 15.608 39.78 15.608 16.319 0 29.489-5.905 39.338-15.316 9.41-8.992 14.994-20.389 18.415-30.653 6.705-20.114 6.701-40.928 6.7-45.943v-.164c0-101.704-82.448-184.151-184.152-184.151s-184.151 82.447-184.151 184.151c0 101.704 82.447 184.152 184.151 184.152 29.367 0 57.177-6.888 81.856-19.152 9.108-4.526 12.822-15.579 8.296-24.686-4.526-9.108-15.579-12.822-24.686-8.296-19.7 9.79-41.913 15.304-65.466 15.304-81.363 0-147.321-65.958-147.321-147.322zm202.567 0c0 30.511-24.735 55.246-55.246 55.246-30.511 0-55.245-24.735-55.245-55.246 0-30.511 24.734-55.245 55.245-55.245 30.511 0 55.246 24.734 55.246 55.245z",
    fill: "#666AF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m635.784 452.083 35.41 19.83 2.479 8.498-4.603 10.269c-6.728 2.243-21.459 6.657-26.558 6.374-5.099-.283-11.804 4.603-14.519 7.082-.944 5.43-2.903 16.926-3.186 19.476-.284 2.549-5.312 15.462-7.791 21.6h-17.351l-6.374-14.164-30.807-73.299-6.728-26.204 4.604-7.082 22.662 9.915 52.762 17.705z",
    fill: "#666AF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M570.595 418.075c-14.495-6.039-29.036 8.502-22.996 22.997l41.666 100c8.149 19.557 36.812 16.251 40.295-4.647l5.198-31.19 31.19-5.199c20.898-3.483 24.204-32.145 4.647-40.294l-100-41.667zm-10.01 17.586c-1.208-2.899 1.7-5.807 4.599-4.6l100 41.667c6.519 2.716 5.417 12.271-1.549 13.432l-31.19 5.198a14.069 14.069 0 0 0-11.564 11.564l-5.198 31.19c-1.161 6.966-10.715 8.068-13.432 1.549l-41.666-100z",
    fill: "#666AF6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.661 477.367h-5.22a2.28 2.28 0 0 1-2.279-2.278v-5.22a2.28 2.28 0 0 1 2.279-2.278h5.22a2.287 2.287 0 0 1 2.278 2.278v5.22c.011 1.251-1.016 2.278-2.278 2.278zm-18.163.41h-5.22a2.287 2.287 0 0 1-2.278-2.279v-5.22a2.28 2.28 0 0 1 2.278-2.278h5.22a2.287 2.287 0 0 1 2.279 2.278v5.22a2.288 2.288 0 0 1-2.279 2.279zm-18.045-.41h-5.22a2.287 2.287 0 0 1-2.278-2.278v-5.22a2.28 2.28 0 0 1 2.278-2.278h5.22a2.287 2.287 0 0 1 2.279 2.278v5.22c.01 1.251-1.016 2.278-2.279 2.278zm-18.099 0h-5.219a2.287 2.287 0 0 1-2.279-2.278v-5.22a2.28 2.28 0 0 1 2.279-2.278h5.219a2.29 2.29 0 0 1 2.29 2.278v5.22a2.304 2.304 0 0 1-2.29 2.278zm-18.098 0h-5.22a2.29 2.29 0 0 1-2.289-2.278v-5.22a2.282 2.282 0 0 1 2.289-2.278h5.22a2.287 2.287 0 0 1 2.278 2.278v5.22a2.287 2.287 0 0 1-2.278 2.278zm53.643-19.734h-5.22a2.287 2.287 0 0 1-2.278-2.278v-5.231a2.287 2.287 0 0 1 2.278-2.278h5.22a2.28 2.28 0 0 1 2.278 2.278v5.22a2.275 2.275 0 0 1-2.278 2.289zm-18.099 0h-5.22a2.287 2.287 0 0 1-2.278-2.278v-5.231a2.287 2.287 0 0 1 2.278-2.278h5.22a2.287 2.287 0 0 1 2.279 2.278v5.22a2.277 2.277 0 0 1-2.279 2.289zm-18.098 0h-5.22a2.29 2.29 0 0 1-2.289-2.278v-5.231a2.29 2.29 0 0 1 2.289-2.278h5.22a2.287 2.287 0 0 1 2.278 2.278v5.22a2.289 2.289 0 0 1-2.278 2.289zm18.751 40.936h-5.22a2.287 2.287 0 0 1-2.278-2.278v-5.22a2.28 2.28 0 0 1 2.278-2.279h5.22a2.288 2.288 0 0 1 2.279 2.279v5.22c.01 1.251-1.016 2.278-2.279 2.278zm17.772 0h-5.22a2.287 2.287 0 0 1-2.278-2.278v-5.22a2.28 2.28 0 0 1 2.278-2.279h5.22a2.287 2.287 0 0 1 2.278 2.279v5.22c.011 1.251-1.016 2.278-2.278 2.278zm-35.871 0h-5.219a2.287 2.287 0 0 1-2.279-2.278v-5.22a2.28 2.28 0 0 1 2.279-2.279h5.219a2.29 2.29 0 0 1 2.29 2.279v5.22a2.304 2.304 0 0 1-2.29 2.278zm523.057-95.093h-5.22a2.281 2.281 0 0 1-2.279-2.279v-5.22a2.28 2.28 0 0 1 2.279-2.278h5.22a2.287 2.287 0 0 1 2.278 2.278v5.22c.011 1.252-1.016 2.279-2.278 2.279zm-18.099 0h-5.22a2.287 2.287 0 0 1-2.278-2.279v-5.22a2.28 2.28 0 0 1 2.278-2.278h5.22a2.287 2.287 0 0 1 2.279 2.278v5.22a2.288 2.288 0 0 1-2.279 2.279zm-18.109 0h-5.22a2.287 2.287 0 0 1-2.278-2.279v-5.22a2.28 2.28 0 0 1 2.278-2.278h5.22a2.287 2.287 0 0 1 2.279 2.278v5.22a2.274 2.274 0 0 1-2.279 2.279zm-18.099 0h-5.219a2.288 2.288 0 0 1-2.279-2.279v-5.22a2.28 2.28 0 0 1 2.279-2.278h5.219a2.29 2.29 0 0 1 2.29 2.278v5.22a2.304 2.304 0 0 1-2.29 2.279zm-18.098 0h-5.22a2.29 2.29 0 0 1-2.289-2.279v-5.22a2.282 2.282 0 0 1 2.289-2.278h5.22a2.287 2.287 0 0 1 2.278 2.278v5.22a2.287 2.287 0 0 1-2.278 2.279zm53.643-19.735h-5.22a2.287 2.287 0 0 1-2.279-2.278v-5.231a2.287 2.287 0 0 1 2.279-2.278h5.22a2.28 2.28 0 0 1 2.278 2.278v5.22a2.275 2.275 0 0 1-2.278 2.289zm-18.099 0h-5.22a2.287 2.287 0 0 1-2.278-2.278v-5.231a2.287 2.287 0 0 1 2.278-2.278h5.22a2.287 2.287 0 0 1 2.279 2.278v5.22a2.276 2.276 0 0 1-2.279 2.289zm-18.098 0h-5.22a2.289 2.289 0 0 1-2.289-2.278v-5.231a2.29 2.29 0 0 1 2.289-2.278h5.22a2.287 2.287 0 0 1 2.278 2.278v5.22a2.289 2.289 0 0 1-2.278 2.289zm18.751 40.936h-5.22a2.287 2.287 0 0 1-2.278-2.278v-5.22a2.28 2.28 0 0 1 2.278-2.278h5.22a2.287 2.287 0 0 1 2.279 2.278v5.22c.01 1.251-1.016 2.278-2.279 2.278zm17.772 0h-5.22a2.287 2.287 0 0 1-2.279-2.278v-5.22a2.28 2.28 0 0 1 2.279-2.278h5.22a2.287 2.287 0 0 1 2.278 2.278v5.22c.011 1.251-1.016 2.278-2.278 2.278zm-35.871 0h-5.219a2.287 2.287 0 0 1-2.279-2.278v-5.22a2.28 2.28 0 0 1 2.279-2.278h5.219a2.29 2.29 0 0 1 2.29 2.278v5.22a2.304 2.304 0 0 1-2.29 2.278z",
    fill: "#E1E4E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M781.032 342.079c-21.983 10.905-51.16-3.116-51.16-3.116s6.484-31.696 28.479-42.585c21.983-10.905 51.148 3.101 51.148 3.101s-6.484 31.695-28.467 42.6z",
    fill: "url(#b)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.877,
    cy: 544.494,
    r: 14.674,
    transform: "rotate(180 321.877 544.494)",
    fill: "#666AF6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 277.425,
    cy: 92.718,
    r: 16.509,
    transform: "rotate(180 277.425 92.718)",
    fill: "#666AF6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 13.757,
    transform: "matrix(-1 0 0 1 173.176 342.683)",
    fill: "#666AF6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 6.42,
    transform: "matrix(-1 0 0 1 686.488 261.412)",
    fill: "#666AF6"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 8.254,
    transform: "matrix(-1 0 0 1 516.759 502.822)",
    fill: "#E1E4E5"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 11.923,
    transform: "matrix(-1 0 0 1 549.273 564.181)",
    fill: "#E1E4E5"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    r: 9.074,
    transform: "matrix(-1 0 0 1 627.447 126.044)",
    fill: "#E1E4E5"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    r: 10.089,
    transform: "matrix(-1 0 0 1 89.52 366.439)",
    fill: "#E1E4E5"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    r: 9.059,
    transform: "scale(1 -1) rotate(-75 128.204 -237.981)",
    fill: "#E1E4E5"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    r: 12.052,
    transform: "matrix(-1 0 0 1 412.387 76.242)",
    fill: "#E1E4E5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 9.271,
    ry: 7.417,
    transform: "matrix(-1 0 0 1 270.187 458.716)",
    fill: "#E1E4E5"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    r: 18.854,
    transform: "scale(1 -1) rotate(-75 274.416 -419.782)",
    fill: "#E1E4E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6 244.473h.243c1.436 20.348 16.569 20.662 16.569 20.662s-16.688.325-16.688 23.838c0-23.513-16.687-23.838-16.687-23.838s15.127-.314 16.563-20.662zm703.641 159.851h.215c1.275 18.417 14.703 18.7 14.703 18.7s-14.807.295-14.807 21.575c0-21.28-14.808-21.575-14.808-21.575s13.423-.283 14.697-18.7z",
    fill: "#E1E4E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 451.951,
    y1: 874.552,
    x2: 435.469,
    y2: -541.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 696.614,
    y1: 376.094,
    x2: 877.931,
    y2: 232.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationAmpersand);
export default __webpack_public_path__ + "static/media/illustration-ampersand.b5412db42c48f80642e50e93d6c81e19.svg";
export { ForwardRef as ReactComponent };